<template>
  <input
    v-if="isFocused"
    ref="inputPrice"
    aria-label="Поле ввода цены в рублях"
    type="text"
    inputmode="numeric"
    v-bind:disabled="disabled"
    v-model="inputValue"
    v-on:blur="onBlur"
    v-on:input="onInput"
  />
  <the-rub
    v-else
    v-bind:show-kop="showKop"
    v-bind:currency="currency"
    v-bind:kop="value"
    v-on:click.native="onFocus"
  />
</template>
<script>
import TheRub from '@/components/TheRub.vue';

/**
 * @description Название события потери фокуса.
 * @type {string}
 */
const NAME_EVENT_BLUR = 'blur';

/**
 * @description Поле ввода стоимости в рублях.
 */
export default {
  components: { TheRub },
  computed: {
    currency() {
      return this.withCurrency ? 'руб' : '';
    },
    showKop() {
      return this.withoutKopeck ? 'hide' : 'auto';
    },
  },
  data() {
    return {
      /**
       * @description Наличие фокуса.
       * @type {boolean}
       */
      isFocused: false,
      /**
       * @description Значение поля ввода.
       * @type {string}
       */
      inputValue: (this.value / 100).toString(),
    };
  },
  methods: {
    onFocus() {
      if (this.disabled) { return; }
      const rub = (this.value / 100).toString();
      this.inputValue = this.withoutKopeck ? this.paseRubles(rub).toString() : rub;
      this.isFocused = true;
      if (this.value === 0) {
        this.inputValue = '';
      }
      this.$nextTick(() => this.$refs.inputPrice.focus());
    },
    onBlur() {
      this.isFocused = false;
      const rub = this.withoutKopeck
        ? this.paseRubles(this.inputValue)
        : this.parseValue(this.inputValue);
      const kop = this.clamp(rub * 100);
      this.inputValue = (kop / 100).toString();
      this.$emit(NAME_EVENT_BLUR, +this.inputValue);
    },
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event
     * @returns {void}
     */
    onInput(event) {
      const { value } = event.target;
      if (value === '') {
        this.$emit('input', this.clamp(0));
        return;
      }
      const rub = this.withoutKopeck
        ? this.paseRubles(value)
        : this.parseValue(value);
      const kop = this.max !== undefined
        ? Math.min(rub * 100, this.max)
        : rub * 100;
      this.inputValue = (kop / 100).toString();
      this.$emit('input', this.clamp(kop));
    },
    /**
     * @description Ограничить значение диапазоном от min до max включительно.
     * @param {number} initialValue
     * @returns {number}
     */
    clamp(initialValue) {
      let value = initialValue;
      if (this.max !== undefined) {
        value = Math.min(value, this.max);
      }
      if (this.min !== undefined) {
        value = Math.max(value, this.min);
      }
      return value;
    },
    /**
     * @description Получить значение.
     * @param {string} value
     * @returns {number}
     */
    parseValue(value) {
      const regex = /[^\d.]/gmu;
      const price = value.replace(regex, '');
      const format = /^[\d]{0,10}(\.[\d]{0,2})?/g;
      const result = format.exec(price);
      if (result !== null) {
        return +result[0];
      }
      return 0;
    },
    /**
     * @description Получить значение в рублях.
     * @param {string} value
     * @returns {number}
     */
    paseRubles(value) {
      const regex = /[^\d.]/gmu;
      const price = value.replace(regex, '');
      const format = /^[\d]{0,10}/g;
      const result = format.exec(price);
      if (result !== null) {
        return +result[0];
      }
      return 0;
    },
  },
  props: {
    disabled: { default: false, type: Boolean },
    max: { default: () => undefined, type: Number },
    min: { default: () => undefined, type: Number },
    value: { required: true, type: Number },
    violations: { default: () => [], type: Array },
    withCurrency: { default: () => true, type: Boolean },
    withoutKopeck: { default: false, type: Boolean },
  },
};
</script>

<style scoped>
input {
  cursor: pointer;
  outline: none;
}
input:focus {
  border-bottom: 1px solid  var(--action-color);
}
</style>
